import { Container, Row, Col, Carousel } from "react-bootstrap";
import sliderDesktop from "../../assets/img/slider.png";
import sliderMobile from "../../assets/img/slider-mobile.png";
// import sliderDesktop2 from "../../assets/img/slider2.jpg";
// import sliderMobile2 from "../../assets/img/slider-mobile2.jpg";

const SliderPortada = () => {
  return (
    <Container fluid className="p-0 m-0">
      <Row className="p-0 m-0">
        <Col md={12} className="mx-auto p-0 m-0">
          <div className="d-md-block d-none">
            <Carousel>
              <Carousel.Item key={1}>
                <a href={"#form"} target={"_self"} rel="noreferrer">
                  <img className="d-block w-100 img-fluid" src={sliderDesktop} alt="Montironi Ford" />
                </a>
              </Carousel.Item>
              {/* <Carousel.Item key={2}>
                <a href={"#form"} target={"_self"} rel="noreferrer">
                  <img className="d-block w-100 img-fluid" src={sliderDesktop2} alt="Montironi Ford" />
                </a>
              </Carousel.Item> */}
            </Carousel>
          </div>
          <div className="d-md-none d-block">
            <Carousel>
              <Carousel.Item key={1}>
                <a href={"#form"} target={"_self"} rel="noreferrer">
                  <img className="d-block w-100 img-fluid" src={sliderMobile} alt="Montironi Ford" />
                </a>
              </Carousel.Item>
              {/* <Carousel.Item key={2}>
                <a href={"#form"} target={"_self"} rel="noreferrer">
                  <img className="d-block w-100 img-fluid" src={sliderMobile2} alt="Montironi Ford" />
                </a>
              </Carousel.Item> */}
            </Carousel>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default SliderPortada;
